import script from "./PageNotFound.vue?vue&type=script&setup=true&lang=js"
export * from "./PageNotFound.vue?vue&type=script&setup=true&lang=js"

import "./PageNotFound.vue?vue&type=style&index=0&id=7d27af6c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d27af6c"]])

export default __exports__